import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Catalog } from '@cureskin/api-client/src/server-api';

export type ProductCardItem = Catalog & { image?: string };

@Component({
  selector: 'app-horizontal-product-card',
  templateUrl: './horizontal-product-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  host: { '[class]': 'hostClasses()' },
})
export class HorizontalProductCardComponent {
  readonly product = input.required<ProductCardItem>();
  readonly quantity = input<number>(0);
  readonly fullBleedImage = input<boolean>(false);
  readonly add = output<ProductCardItem>();
  readonly remove = output<ProductCardItem>();
  readonly view = output<ProductCardItem>();

  protected readonly hostClasses = computed((): string => {
    const base = 'tw-w-[70vw] tw-h-[120px] tw-bg-white tw-shadow-z4 tw-flex-shrink-0 tw-flex-grow-0 '
      + 'tw-min-w-[70vw] tw-max-w-[70vw] tw-rounded-2 tw-flex tw-items-center tw-overflow-hidden tw-font-body tw-gap-2 last:tw-mr-4';
    return this.fullBleedImage() ? `${base} tw-pr-3` : `${base} tw-py-3 tw-px-2`;
  });

  onAdd(): void {
    this.add.emit(this.product());
  }

  onRemove(): void {
    this.remove.emit(this.product());
  }

  onView(): void {
    this.view.emit(this.product());
  }
}
